<script lang="ts" setup>
import {MoonIcon, ComputerDesktopIcon, SunIcon} from "@heroicons/vue/24/outline"
import {Menu, MenuButton} from '@headlessui/vue'
import {
  MoonIcon as Moon,
  ComputerDesktopIcon as Desktop,
  SunIcon as Sun,
} from '@heroicons/vue/20/solid'
import {ref} from "vue";
import MenuItemsDropdown from "@/Components/App/Global/MenuItemsDropdown.vue";
import MenuItemDropdown from "@/Components/App/Global/MenuItemDropdown.vue";
import {changeDarkMode} from "@/Support/Common/Functions/changeDarkMode";
import {storeToRefs} from "pinia";
import {useAppLayout} from "@/stores/appLayout";

const {currentScreenMode} = storeToRefs(useAppLayout())
</script>
<template>
  <Menu as="div" class="relative inline-block text-left">
    <div>
      <MenuButton
        class="
          shrink-0
          p-1
          text-neutral-500
          lg:text-neutral-200
          rounded-full
          hover:text-neutral-400 lg:hover:text-white
          hover:bg-white/10
          focus:outline-hidden
        "
      >
      <span class="sr-only">
        {{ __('Change Dark Mode') }}
      </span>
        <SunIcon
          v-if="currentScreenMode === 'light'" aria-hidden="true"
          class="h-6 w-6"
        />
        <MoonIcon
          v-else-if="currentScreenMode === 'dark'" aria-hidden="true"
          class="h-6 w-6"
        />
        <ComputerDesktopIcon v-else aria-hidden="true" class="h-6 w-6" />
      </MenuButton>

    </div>

    <MenuItemsDropdown class="-right-0">
      <div class="py-1">
        <MenuItemDropdown
          :icon-active="currentScreenMode === 'light'"
          :icon="Sun"
          click-value="light"
          title="Light"
          @clicked="changeDarkMode"
        />
        <MenuItemDropdown
          :icon-active="currentScreenMode === 'dark'"
          :icon="Moon"
          click-value="dark"
          title="Dark"
          @clicked="changeDarkMode"
        />
      </div>
      <div class="py-1">
        <MenuItemDropdown
          :icon-active="currentScreenMode === 'system'"
          :icon="Desktop"
          click-value="system"
          title="System"
          @clicked="changeDarkMode"
        />
      </div>

    </MenuItemsDropdown>
  </Menu>
</template>

